import App from '@/App.vue'
import i18n, { loadLocale, parseDefaultLocale } from '@/plugins/i18n'
import router from '@/router'
import '@/assets/css/main.css'
import 'vue-final-modal/style.css'
import 'vue-sonner/style.css'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { createVfm } from 'vue-final-modal'
import { createManager } from '@vue-youtube/core'
import sentryConfig from '@/config/sentry'
import * as Sentry from '@sentry/vue'
import gtmConfig from '@/config/gtm'
import { createGtm } from '@gtm-support/vue-gtm'
import { VueRecaptchaPlugin } from 'vue-recaptcha'
import recaptchaConfig from '@/config/recaptcha'
import { sanitizedHtml } from '@/directives/sanitized-html'
import { sanitizedHref } from '@/directives/sanitized-href'
import { createHead } from '@unhead/vue/client'

// Create vue app
const app = createApp(App)
const head = createHead()

Sentry.init({
  app,
  ...sentryConfig,
})

// Use plugins
app.use(head)
app.use(router)
app.use(createPinia())
app.use(i18n)
app.use(createVfm())
app.use(createGtm(gtmConfig))
app.use(VueRecaptchaPlugin, recaptchaConfig)
app.use(createManager({
  deferLoading: {
    enabled: true,
    autoLoad: true,
  },
}))

app.directive('sanitizedHtml', sanitizedHtml)
app.directive('sanitizedHref', sanitizedHref)

// Load the default locale before mount so first paint has translations.
// Other locales lazy-load on demand via loadLocale() in store/layout sites.
await loadLocale(parseDefaultLocale())

app.mount('#app')
